import {
  Filter
} from '../../../common/filter';

export const FilterCutsModalController = function(
  $scope,
  CurrentFilterService,
  $modalInstance,
  cuts,
  RouterService,
  $timeout,
) {
  $scope.filterAsText = {};
  $scope.errorMessage = {};
  $scope.cuts = cuts;

  $scope.$watch('cuts.query', () => {
    $scope.cuts.cutsText = Filter.getFiltersQueryCode(cuts.filters, cuts.query);
  }, true);


  function updateModalSize() {
    const modalWin = $('.modal.fade');
    const height = window.innerHeight * 0.96 - $('.modal-header').outerHeight() - $('.modal-footer').outerHeight();
    modalWin.find('.modal-body1').height(height);
    // modalWin.width(900);
  }

  $modalInstance.opened.then(function() {
    $timeout(() => {
      updateModalSize();
    }, 100);
  });


  $scope.updateFromText = () => {
    $scope.errorMessage.text = null;
    $scope.cuts.filters = Filter.getFiltersFromText($scope.cuts.cutsText);

    try {
      const query = Filter.getQueryFromText($scope.cuts.cutsText);
      if (!angular.equals($scope.cuts.query, query)) $scope.cuts.query = query;
    } catch (err) {
      $scope.errorMessage.text = err.message;
      $scope.errorMessage.source = 'query-text';
      console.error(err.message);
    }
  };

  $scope.filterTab = 'query';
  $scope.onQueryTextGotFocus = () => {
    $scope.errorMessage.filterUnchecked = true;
    $scope.errorMessage.text = gettext('Для сохранения кода фильтра переместите фокус мышки из текстового редактора на любую другую часть формы');
  };

  $scope.cancel = () => $modalInstance.dismiss('cancel');
  $scope.ok = () => {
    if (!$scope.errorMessage.text) $modalInstance.close(cuts);
  };
};



// WEBPACK FOOTER //
// ./src/filter/editor/tabs/filter-cuts.component.js